/** Compatibility exports for the Hush catalog and its legacy town palettes. */
import { HUSH_PROP_TEMPLATES } from './pieceCatalog/hush';
export { HUSH_PROP_TEMPLATES };
export type HushPropTemplate = keyof typeof HUSH_PROP_TEMPLATES;

export const HUSH_PROP_PALETTES = {
  coastal_salt: {
    primary: '#d7bc83', shade: '#a88a54', roof: '#6c9bae', roofEdge: '#aac8ce',
    wood: '#826b4d', woodEdge: '#a18a61', stone: '#8c9c96', iron: '#2b4145',
    glass: '#ffe3a0', glassCore: '#f0deb0',
  },
  nook_warm: {
    primary: '#e5c991', shade: '#a88a54', roof: '#6c9bae', roofEdge: '#aac8ce',
    wood: '#927754', woodEdge: '#a18a61', stone: '#949f8b', iron: '#2b4145',
    glass: '#ffe8ab', glassCore: '#f5e4bf',
  },
} as const;
